//* 公共函数
import { register } from "@various/utils";
//* 组件
import Simplebar from "./index.vue";

export const UiSimplebar = register.use(Simplebar, "component") as typeof Simplebar;
export * from "./src/component";
export default UiSimplebar;
